var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"register-container"},[_c('LeftSide',{attrs:{"isBusiness":true,"showBack":_vm.showBack}}),_c('RightSide'),_c('Footer')],1),_c('FooterPage'),_c('vue-snotify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }